import React from "react";
import { Link } from "react-router-dom";
import "./OtherTools.css";

import downloadIcon from "../../assets/OtherTools/download.png";
import headlineIcon from "../../assets/OtherTools/headline.png";
// import carouselIcon from "../../assets/OtherTools/carousel.png";
import summaryIcon from "../../assets/OtherTools/summary.png";

const tools = [
  {
    name: "LinkedIn Video Downloader",
    icon: downloadIcon,
    link: "/dashboard/free-tools/linkedin-video-downloader", // Always dashboard route
  },
  {
    name: "LinkedIn Headline Generator",
    icon: headlineIcon,
    link: "/dashboard/free-tools/linkedin-headline-generator",
  },
  {
    name: "LinkedIn Summary Generator",
    icon: summaryIcon,
    link: "/dashboard/free-tools/linkedin-summary-generator",
  },
  // {
  //   name: "LinkedIn Carousel Generator",
  //   icon: carouselIcon,
  //   link: "/linkedin-carousel-generator",
  // },
];

const OtherTools = () => {
  return (
    <div className="other-tools">
      <h2 className="other-tools-title">Free Tools</h2>
      <div className="other-tools-grid">
        {tools.map((tool) => (
          <Link key={tool.name} to={tool.link} className="tool-card">
            <img src={tool.icon} alt={tool.name} className="tool-icon" />
            <span className="tool-name">{tool.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OtherTools;
